<template>
  <div class="v-pdf" :style="{'height': `${height}px`}">
    <pdf
      v-for="i in renderCount"
      class="v-pdf__page"
      :key="i"
      :src="loadingTask"
      :page="i"
      @page-loaded="onPageLoaded"
    />
    <v-loading v-if="loading" class="v-pdf__loading" />
  </div>
</template>

<script>
import pdf from "vue-pdf";

export default {
  components: {
    pdf
  },
  props: {
    src: {
      type: String,
      required: true
    },
    height: {
      type: Number,
      default: 300
    }
  },
  data() {
    return {
      loadingTask: null,
      loading: true,
      pageCount: null,
      renderCount: 0
    };
  },
  created() {
    this.loadingTask = pdf.createLoadingTask(this.src);
  },
  mounted() {
    this.loadingTask.promise.then(pdf => {
      this.pageCount = pdf.numPages;
      this.renderCount = 1;
    });
  },
  methods: {
    onPageLoaded(pageNumber) {
      // Render pages incrementally to avoid exceptions:
      // https://github.com/FranckFreiburger/vue-pdf/issues/202
      if (pageNumber < this.pageCount) {
        this.renderCount++;
      }

      this.loading = false;
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../sass/component.scss";

.v-pdf {
  position: relative;
  overflow-x: hidden;
  overflow-y: auto;
  border: 1px solid theme-color("placeholder");

  &__page {
    border: 4px solid theme-color("light");
    border-bottom-width: 6px;

    &:last-child {
      border-bottom-width: 4px;
    }
  }

  &__loading {
    height: 100%;
  }
}
</style>
